var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.check.apply(null, arguments)}}},[_vm._v("Check Outbound Connection")])])}
var staticRenderFns = []

export { render, staticRenderFns }